import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	clientPrefix: "VITE_",
	client: {
		VITE_BACKEND_API_URL: z.string().url(),
		VITE_CLERK_PUBLISHABLE_KEY: z.string().min(1),
		VITE_PUBLIC_SITE_URL: z.string().url(),
	},
	runtimeEnv: import.meta.env,
	emptyStringAsUndefined: true,
});
